/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/components/shared/InvestigationPanel.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Button } from "../ui/button.js";
import { __jacCallFunction } from "@jac/runtime";
import { useState } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
import { _jac } from "@jac/prelude";
async function investigate_report(incident_id, person_id, claim_id, passphrase) {
  return await __jacCallFunction("investigate_report", {"incident_id": incident_id, "person_id": person_id, "claim_id": claim_id, "passphrase": passphrase});
}
let PANEL_PRICE_USD_PER_MILLION_TOKENS = 0.0;
function usage_line(usage_source, total_tokens) {
  if (!usage_source) {
    return "";
  }
  let label = ((usage_source === "provider") ? "provider-reported" : "estimate");
  if ((PANEL_PRICE_USD_PER_MILLION_TOKENS <= 0.0)) {
    return `${total_tokens} tokens (${label}); price not configured`;
  }
  let cost = ((total_tokens / 1000000.0) * PANEL_PRICE_USD_PER_MILLION_TOKENS);
  return `${total_tokens} tokens (${label}); about $${_jac.builtin.format(cost, ".4f")}`;
}
function InvestigationPanel(props) {
  const {snapshot, onRefresh, focusRequest: focusRequest = 0} = props;
  const [selectedId, setSelectedId] = useState("");
  const [selectedClaim, setSelectedClaim] = useState("");
  const [passphrase, setPassphrase] = useState("");
  const [busy, setBusy] = useState(false);
  const [liveResponse, setLiveResponse] = useState(null);
  const [liveIncident, setLiveIncident] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (((focusRequest <= 0) || (snapshot.investigations.length === 0))) {
      return;
    }
    let best = snapshot.investigations[0];
    for (const inv of snapshot.investigations) {
      if ((inv.citations.length > _jac.builtin.len(best.citations))) {
        best = inv;
      }
    }
    setSelectedId(best.person_id);
    setSelectedClaim(best.claim_id);
    setLiveResponse(null);
  }, [focusRequest]);
  let selectedPeople = snapshot.people.filter(p => (p.id === selectedId)).map(p => p);
  let people = (_jac.builtin.bool(selectedPeople) ? selectedPeople : snapshot.people.slice(0, 1));
  let personId = (_jac.builtin.bool(people) ? people[0].id : "");
  let claims = (_jac.builtin.bool(people) ? people[0].claims : []);
  let claimIds = claims.map(c => c.id);
  let claimId = (claimIds.includes(selectedClaim) ? selectedClaim : (_jac.builtin.bool(claims) ? claims.at((-1)).id : ""));
  let matching = snapshot.investigations.filter(inv => ((inv.person_id === personId) && (inv.claim_id === claimId))).map(inv => inv);
  _jac.list.sort(matching, inv => {
  return inv.run_at;
});
  let saved = (_jac.builtin.bool(matching) ? matching.at((-1)) : null);
  async function investigate() {
    let response;
    setBusy(true);
    setError("");
    setLiveResponse(null);
    try {
      response = await __jacCallFunction("investigate_report", {"incident_id": snapshot.incident_id, "person_id": personId, "claim_id": claimId, "passphrase": passphrase});
      if (!_jac.builtin.bool(response)) {
        setError("No response received. Try again; completed checks are cached.");
      } else {
        setLiveResponse(response);
        setLiveIncident(snapshot.incident_id);
        await onRefresh();
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        setError("Could not check the report. Your source records have not changed.");
      } else {
        throw __jac_e;
      }
    }
    setBusy(false);
  }
  let unsavedLive = ((((liveIncident === snapshot.incident_id) && liveResponse) && ["UNAVAILABLE", "FAILED", "BUDGET_LIMIT", "PARTIAL"].includes(_jac.poly.call(liveResponse, "get", "status"))) ? liveResponse : null);
  return __jacJsx("section", {"id": "report-investigation", "className": "mt-6 flex scroll-mt-4 flex-col gap-3 rounded-md border border-border bg-card p-4", "aria-label": "Report investigation"}, [__jacJsx("div", {}, [__jacJsx("h3", {"className": "font-display text-xl"}, ["Where did this report come from?"]), __jacJsx("p", {"className": "text-sm text-muted-foreground"}, ["Pick a report. Trace checks who it quotes and compares it with that source when it can. A person makes the final call."])]), __jacJsx("div", {"className": "flex flex-wrap items-end gap-3"}, [__jacJsx("label", {"className": "flex min-w-48 flex-col gap-1 text-sm"}, [__jacJsx("span", {}, ["Person record"]), __jacJsx("select", {"value": personId, "disabled": busy, "onChange": e => {
    setSelectedId(e.target.value);
    setSelectedClaim("");
    setLiveResponse(null);
  }, "className": "rounded-md border border-input bg-card p-2 text-foreground"}, [(() => {
    let __jac_view_kids = [false];
    __jac_view_kids[0] = (() => {
      let __jac_view_kids_1 = [];
      for (const person of snapshot.people) {
        __jac_view_kids_1.push(__jacJsx("option", {"key": person.id, "value": person.id}, [person.name]));
      }
      return __jac_view_kids_1;
    })();
    return __jacJsx(null, {}, __jac_view_kids);
  })()])]), __jacJsx("label", {"className": "flex min-w-48 flex-col gap-1 text-sm"}, [__jacJsx("span", {}, ["Source report"]), __jacJsx("select", {"value": claimId, "disabled": busy, "onChange": e => {
    setSelectedClaim(e.target.value);
    setLiveResponse(null);
  }, "className": "rounded-md border border-input bg-card p-2 text-foreground"}, [(() => {
    let __jac_view_kids_2 = [false];
    __jac_view_kids_2[0] = (() => {
      let __jac_view_kids_3 = [];
      for (const claim of claims) {
        __jac_view_kids_3.push(__jacJsx("option", {"key": claim.id, "value": claim.id}, [((claim.source_name + " \u00b7 ") + claim.claim_type)]));
      }
      return __jac_view_kids_3;
    })();
    return __jacJsx(null, {}, __jac_view_kids_2);
  })()])]), __jacJsx("label", {"className": "flex min-w-48 flex-col gap-1 text-sm"}, [__jacJsx("span", {}, ["Live passphrase (only needed for a new live check)"]), __jacJsx("input", {"type": "password", "autoComplete": "off", "value": passphrase, "disabled": busy, "onChange": e => {
    setPassphrase(e.target.value);
  }, "className": "rounded-md border border-input bg-card p-2 text-foreground"}, [])]), __jacJsx(Button, {"disabled": ((busy || !personId) || !claimId), "onClick": investigate}, [(busy ? "Checking report\u2026" : "Investigate")])]), (error && __jacJsx("p", {"role": "alert", "className": "text-sm text-destructive"}, [error])), (unsavedLive && __jacJsx("div", {"role": "status", "className": "flex flex-col gap-2 text-sm"}, [__jacJsx("strong", {}, [String(_jac.poly.call(unsavedLive, "get", "status"))]), __jacJsx("p", {}, [_jac.poly.call(unsavedLive, "get", "message")])])), ((saved && !unsavedLive) && __jacJsx("div", {"role": "status", "className": "flex flex-col gap-3 text-sm"}, [__jacJsx("div", {"className": "flex flex-wrap items-center gap-2"}, [__jacJsx("span", {"className": ("rounded-full border px-2 py-0.5 text-xs font-medium " + (((saved.mode === "LIVE") ? "border-status-safe/40 bg-status-safe-soft text-status-safe" : ((saved.mode === "REPLAYED") ? "border-status-neutral/40 bg-status-neutral-soft text-status-neutral" : "border-status-warning/40 bg-status-warning-soft text-status-warning"))))}, [saved.mode]), __jacJsx("strong", {}, [saved.status]), __jacJsx("span", {"className": "text-xs text-muted-foreground"}, [("Model: " + saved.model)])]), __jacJsx("p", {}, [saved.message]), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, [(("Recorded run: " + (saved.run_at || "unknown")) + " (viewing now)")]), (saved.usage_source && __jacJsx("p", {"className": "text-xs text-muted-foreground"}, [usage_line(saved.usage_source, saved.total_tokens)])), (saved.trace && __jacJsx("ol", {"className": "list-decimal space-y-1 pl-5"}, [(() => {
    let __jac_view_kids_4 = [false];
    __jac_view_kids_4[0] = (() => {
      let __jac_view_kids_5 = [];
      for (const step of saved.trace) {
        __jac_view_kids_5.push(__jacJsx("li", {"key": step}, [step]));
      }
      return __jac_view_kids_5;
    })();
    return __jacJsx(null, {}, __jac_view_kids_4);
  })()])), (saved.citations && __jacJsx("div", {"className": "flex flex-col gap-2"}, [__jacJsx("h4", {"className": "font-medium"}, ["Source evidence"]), (() => {
    let __jac_view_kids_6 = [false];
    __jac_view_kids_6[0] = (() => {
      let __jac_view_kids_7 = [];
      for (const citation of saved.citations) {
        __jac_view_kids_7.push(__jacJsx("p", {"key": citation.claim_id, "className": "break-all text-xs text-muted-foreground"}, [((("Claim: " + citation.claim_id) + " \u00b7 Source: ") + citation.source_name)]));
      }
      return __jac_view_kids_7;
    })();
    return __jacJsx(null, {}, __jac_view_kids_6);
  })()]))])), (((!saved && !unsavedLive) && !error) && __jacJsx("p", {"className": "text-sm text-muted-foreground"}, ["No check recorded yet for this report."]))]);
}
/*jac:refresh-boundary*/;
export {InvestigationPanel};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:investigate_report": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=InvestigationPanel.js.map
